import * as React from 'react';
/* eslint-disable react-hooks/exhaustive-deps */
// A semantic wrapper around useEffect for the case to only call on mount
export function useMountEffect(callback: React.EffectCallback) {
  return React.useEffect(callback, []);
}
